<template>
  <v-container>
    <label>
      <b>Información del nivel</b>
    </label>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field
          :error-messages="typeLevelErrors"
          v-model="levelForm.typeLevel"
          counter="50"
          maxlength="50"
          @input="emitUpdate"
          label="Nombre"
          placeholder="Nombre"
          outline
          required
          :disabled="permits['UPDATE_LEVELS'] ? false : true"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field
          :error-messages="abbrErrors"
          v-model="levelForm.abbr"
          @input="emitUpdate"
          label="Abreviación"
          placeholder="Abreviación"
          outline
          maxlength="3"
          mask="NNN"
          counter
          required
          :disabled="permits['UPDATE_LEVELS'] ? false : true"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-menu
          ref="clock"
          v-model="modals.clock"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="levelForm.departureTime"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :error-messages="departureTimeErrors"
              outline
              label="Hora de salida"
              placeholder="hh:mm"
              prepend-icon="access_time"
              readonly
              v-on="on"
              :value="departureTimeFixed"
              :disabled="permits['UPDATE_LEVELS'] ? false : true"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="modals.clock"
            v-model="levelForm.departureTime"
            @input="emitUpdate"
            full-width
            format="24hr"
            @click:minute="$refs.clock.save(levelForm.departureTime)"
            color="secondary"
            header-color="primary"
            use-seconds
            scrollable
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <!-- <v-flex xs12 sm4>
          <vue-timepicker 
            :value=this.fixPMamDate(levelForm.departureTime)
            @input="emitUpdate"
            full-width
            format="hh:mm:ss a"
            @click:minute="$refs.clock.save(levelForm.departureTime)"
            color="secondary"
            header-color="primary"
            manual-input
        ></vue-timepicker>
      </v-flex> -->
      <v-flex xs12 text-xl-center>
        <v-checkbox
          :disabled="!lAdding"
          v-model="levelForm.isExtra"
          label="Nivel extracurricular"
          color="secondary"
          hide-details
        ></v-checkbox>
      </v-flex>
      <v-flex xs12 sm4 offset-sm4 v-if="lAdding">
        <v-btn :disabled="loading" round block color="gradiente" dark @click="createLevel">Guardar</v-btn>
      </v-flex>
      <v-flex xs12 sm4 offset-sm4 v-if="!lAdding">
        <v-btn
          :disabled="permits['DELETE_LEVELS'] ? false : true"
          round
          block
          color="gradiente"
          dark
          @click="modals.confirm = true;"
        >Eliminar</v-btn>
      </v-flex>
    </v-layout>
    <confirm
      v-model="modals.confirm"
      @desition="desition"
      title="Eliminar nivel"
      description="¡Aviso!. Este proceso es <b>destructivo</b>,
    por lo que no podrá recuperar la información eliminada. <br> Se eliminarán los grados y los grupos dentro del nivel.<br> ¿Estás seguro que deseas continuar con la operación?"
    ></confirm>
  </v-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import confirm from "../../Dialogs/Confirm";
import VueTimepicker from 'vue2-timepicker';
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css';

export default {
  validations: {
    levelForm: {
      departureTime: { required },
      typeLevel: { required },
      abbr: { required }
    }
  },
  components: {
    confirm,
    VueTimepicker
  },
  props: ["lAdding", "lvl", "lUpdate", "permits"],
  watch: {
    lUpdate() {
      if (this.lUpdate) {
        this.updateLevel();
      }
    },
    lAdding() {
      if (this.lAdding) {
        this.$v.$reset();
      }
    },
    lvl() {
      this.levelForm = this.lvl;
    }
  },
  data: () => ({
    levelForm: {
      departureTime: "",
      typeLevel: "",
      abbr: "",
      isExtra: false
    },
    counter: 0,
    loading: false,
    modals: {
      clock: false,
      confirm: false
    },
     dataClock: {
      hh: '03',
      mm: '05',
      ss: '00',
      a: 'am'
    }
  }),
  methods: {
    createLevel() {
      this.$v.levelForm.$touch();
      if (!this.$v.levelForm.$invalid) {
        this.$emit("loading");
        this.loading = true;
        var obj = this.levelForm;
        obj.branch = {
          id: this.getBranch.id
        };
        this.$store
          .dispatch("level/createLevel", obj)
          .then(response => {
            this.$emit("success");
            this.loading = false;
          })
          .catch(error => {
            this.$emit("error");
            this.loading = false;
          });
      }
    },
    updateLevel() {
      this.$v.levelForm.$touch();
      if (!this.$v.levelForm.$invalid) {
        this.$emit("loading");
        this.$store
          .dispatch("level/updateLevel", this.levelForm)
          .then(response => {
            this.$emit("sUpdate");
            this.$emit("successUpdate");
          })
          .catch(error => {
            this.$emit("sUpdate");
            this.$emit("error");
          });
      }
    },
    desition(event) {
      if (event) {
        this.$emit("loading");
        this.$store
          .dispatch("level/deleteLevel", this.levelForm)
          .then(response => {
            this.$emit("success");
            this.$emit("deleted");
          })
          .catch(error => {
            if (error.status == 200 && error.data.code == 400) {
              this.$emit("error", 400);
            }
          });
      }
    },
    emitUpdate() {
      this.$emit("flagUpdate");
    },
    fixPMamDate(departureTime2){
        var digitos = departureTime2.replaceAll(':','');
         if( digitos.length == 6){
            console.log("si son 6 "+digitos);
            //obteniendo valores
            var hora = digitos.substring(0, 2);
            var minutos = digitos.substring(2, 4);
            var segundos = digitos.substring(4,6);
            var amPM = "";
            var prefZero = "0";

            if(hora=="00"){
                hora = 12;
                amPM = 'am';
            }else if(hora<12){
                amPM = 'am';
            }else if(hora==12){
                amPM = 'pm';
            }else if(hora>12) {
                hora = hora-12;
                console.log("hora recortada:"+hora);
                hora = prefZero.concat(hora);
                amPM = 'pm';

                //hora = hora.concat('0',0);
            }
            console.log("hora: "+hora+ "minutos: "+minutos + "segundos: "+segundos);
            console.log("formato: "+hora+":"+minutos+":"+segundos+" "+amPM);

            return hora+":"+minutos+":"+segundos+" "+amPM;

           

         }else{
            console.log("FORMATO INCORRECTO  ");

            return "12:00:00 am";

         }


        //hh:mm:ss A
    },
  },
  computed: {
    departureTimeFixed() {
      return this.levelForm.departureTime != null
        ? this.levelForm.departureTime.split(":")[0] +
            ":" +
            this.levelForm.departureTime.split(":")[1]
        : "";
    },
    typeLevelErrors() {
      const errors = [];
      if (!this.$v.levelForm.typeLevel.$dirty) return errors;
      !this.$v.levelForm.typeLevel.required &&
        errors.push("Nombre obligatorio");

      return errors;
    },
    abbrErrors() {
      const errors = [];
      if (!this.$v.levelForm.abbr.$dirty) return errors;
      !this.$v.levelForm.abbr.required &&
        errors.push("Abreviación obligatoria");
      return errors;
    },
    departureTimeErrors() {
      const errors = [];
      if (!this.$v.levelForm.departureTime.$dirty) return errors;
      !this.$v.levelForm.departureTime.required &&
        errors.push("Hora de salida obligatoria");
      return errors;
    },
    ...mapGetters(["getBranch"])
  }
};
</script>

<style>
</style>
